"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68557],{

/***/ 872440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ProductCheckoutInfo; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(287037);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179185);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(991822);
/* harmony import */ var _Common_Gift_Gift_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(343297);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(528938);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WrapperInfo = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const StyledCurrency = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)`
  font-weight: bold;
`;
const StyledTextCurrency = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span`
  width: max-content;
  display: inline-block;
  font-weight: bold;
`;
const StyledGift = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_Common_Gift_Gift_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Gift */ .n)`
  margin: 0.5rem 0;
`;
const GiftBlock = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  margin-left: 3rem;
`;
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
`;
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  flex: 1;
  margin-left: 1rem;
`;
const ListedPrice = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const DiscountWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const StrikeThroughPrice = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ theme }) => {
  return `
  text-decoration: line-through;
  color: ${theme == null ? void 0 : theme.colors.gray130};
  font-size: 0.75rem;
`;
});
const ItemNote = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ maxHeight, line, expanded, theme }) => {
  return `
  display: -webkit-box;
  -webkit-line-clamp: ${expanded ? "unset" : line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  max-height: ${expanded ? "fit-content" : maxHeight};
  width: 100%;
  line-height: 1.5em;
  white-space: normal;
  font-style: italic;
  color: ${theme.colors.neutral};
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 0.25em;
`;
});
const ProductCheckoutInfo = (_a) => {
  var _b = _a, {
    imageUrl,
    name,
    quantity,
    price,
    unitPrice,
    gifts,
    targetPath,
    disableProductPromo,
    consultationServiceFee = 0,
    comboImages = [],
    tags,
    displayPrice,
    sku,
    attributeDescription,
    strikeThroughDisplayPrice,
    formatNumber,
    note,
    displayTotalAvailable
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "name",
    "quantity",
    "price",
    "unitPrice",
    "gifts",
    "targetPath",
    "disableProductPromo",
    "consultationServiceFee",
    "comboImages",
    "tags",
    "displayPrice",
    "sku",
    "attributeDescription",
    "strikeThroughDisplayPrice",
    "formatNumber",
    "note",
    "displayTotalAvailable"
  ]);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperInfo, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, comboImages.length > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .ComboImage */ .Z, {
    images: comboImages
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, {
    height: 80,
    width: 80,
    borderRadius: 4,
    contain: true,
    border: true,
    src: imageUrl,
    alt: "product"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, !!targetPath ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_7__/* .CustomLink */ .x, {
    targetPath,
    targetType: "_blank",
    passHref: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 2,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_9__/* .Tag */ .V, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 2,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_9__/* .Tag */ .V, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name), !!displayTotalAvailable && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__/* .Caption */ .YS, {
    level: 1,
    color: "warning"
  }, displayTotalAvailable), !!attributeDescription && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, attributeDescription), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_8__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_10__.t)("S\u1ED1 l\u01B0\u1EE3ng"), " ", quantity), !!sku ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: price,
    formattedValue: formatNumber ? formatNumber(price) : void 0
  }), unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DiscountWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListedPrice, {
    horizontal: false,
    size: "md",
    value: unitPrice,
    lineThrough: true
  })), strikeThroughDisplayPrice && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DiscountWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StrikeThroughPrice, null, strikeThroughDisplayPrice))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTextCurrency, null, displayPrice))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, !!gifts.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftBlock, null, gifts.map((gift, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGift, {
    key: index,
    image: {
      src: gift.imageUrl,
      height: 16,
      width: 16
    },
    border: false,
    text: gift.name
  })))), !!note && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemNote, {
    maxHeight: "4.5em",
    expanded,
    line: 3,
    onClick: () => setExpanded(!expanded)
  }, `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_10__.t)("Ghi ch\xFA")}: ${note}`)));
};




/***/ }),

/***/ 528938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 343297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Gift; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179185);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((props) => `
flex: 1;
font-size: 0.75rem;
margin-top: auto;
margin-bottom: auto;
margin-left: 0.5rem;
text-decoration: ${props.disableProductPromo ? "line-through" : "none"};
`);
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  background: #fff;
  cursor: pointer;
`;
const ImageWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  align-items: start;
  height: fit-content;
  width: fit-content;
`;
const Gift = (_a) => {
  var _b = _a, {
    image,
    text,
    link,
    disableProductPromo,
    cartLineSelected = true,
    border = true
  } = _b, props = __objRest(_b, [
    "image",
    "text",
    "link",
    "disableProductPromo",
    "cartLineSelected",
    "border"
  ]);
  if (link)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: link,
      legacyBehavior: true
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, __spreadProps(__spreadValues({
      contain: true,
      height: 32,
      width: 32,
      border
    }, image), {
      borderRadius: 2
    }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
      disableProductPromo: !!disableProductPromo
    }, text)));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, __spreadProps(__spreadValues({
    contain: true,
    height: 32,
    width: 32,
    border
  }, image), {
    borderRadius: 2
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
    disableProductPromo: !!disableProductPromo && cartLineSelected
  }, text));
};




/***/ }),

/***/ 287037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ComboImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);




const ComboImageWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  width: props.width ? `${props.width}px` : "80px",
  height: props.height ? `${props.height}px` : "80px",
  background: "#F8F8FC",
  borderRadius: "4px",
  position: "relative",
  cursor: "pointer"
}));
const ChildImage = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img((props) => ({
  borderRadius: "4px",
  width: props.width ? `${props.width}px` : "34px",
  height: props.height ? `${props.height}px` : "34px",
  margin: "4px 0 0 4px",
  border: props.isContainBorder ? "solid 1px #E4E5F0" : "unset"
}));
const RemainingNumber = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: rgba(27, 29, 41, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  border: 4px;
  right: 4px;
  bottom: 4px;
`;
const IMAGE_LIMIT = 4;
const ComboImage = ({
  images,
  alt = [],
  keys = [],
  width,
  height,
  childHeight,
  childWidth,
  isContainBorder
}) => {
  const isSingleImage = images.length === 1;
  if (isSingleImage)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
      src: images.shift(),
      height: height || 80,
      width: width || 80,
      alt: "product",
      contain: true,
      border: true
    });
  const remainImage = images.length - IMAGE_LIMIT;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComboImageWrapper, {
    width,
    height
  }, images.slice(0, IMAGE_LIMIT).map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChildImage, {
    width: childWidth,
    height: childHeight,
    isContainBorder,
    src: image,
    alt: alt[index],
    key: keys[index] || index
  })), remainImage > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RemainingNumber, null, "+", remainImage + 1));
};




/***/ }),

/***/ 468557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniCart": function() { return /* binding */ MiniCart; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93512);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(650983);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(872440);
/* harmony import */ var components_EmptyCartPanel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(368139);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534090);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(428247);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(305857);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n  max-height: 400px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.7rem 1rem;\n  text-decoration: none;\n  &:hover {\n    color: #fff;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem 0;\n  border-top: 1px dashed #e0e0e0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  line-height: 26px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  height: 260px;\n  overflow-y: auto;\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #999;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  width: 250px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: 500;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




// TODO: replace teko/ui with DS







const MiniCart = (param)=>{
    let { onHide , showShippingFee =true  } = param;
    const { flattenItems , cart: { grandTotalAmount  } ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useCartV2 */ .T6)();
    const formatNumber = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useFormatNumber */ .D)();
    if (flattenItems.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmptyCartWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledEmptyCartPanel, {})
            })
        });
    }
    //Cart shipping fee is deprecated
    const shippingFee = 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {
                children: flattenItems.map((item)=>{
                    var ref;
                    const promotions = [];
                    (ref = item.promotions) === null || ref === void 0 ? void 0 : ref.map((group)=>{
                        promotions.push(...group.promotions.filter((promotion)=>!!promotion.title));
                    });
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .ProductCheckoutInfo */ .X, _objectSpreadProps(_objectSpread({
                        mb: 3,
                        imageUrl: item.imageUrl,
                        name: item.title || item.name,
                        price: item.price,
                        quantity: item.quantity
                    }, !!item.sku ? {
                        targetPath: "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(item.title || item.name), "-s").concat(item.sku, ".html")
                    } : {}), {
                        gifts: promotions.filter((promotion)=>!!promotion.cartPromotionId).map((promotion)=>({
                                name: promotion.title,
                                imageUrl: promotion.imageUrl,
                                isDefault: true
                            })),
                        tags: item.tags,
                        sku: item.sku,
                        displayPrice: item.displayPrice,
                        attributeDescription: item.attributeDescription,
                        formatNumber: formatNumber
                    }), item.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLine, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Tổng tiền ({{totalCartItemsSelected}}) sản phẩm", {
                                    totalCartItemsSelected: flattenItems.length
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GrandTotal, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Currency */ .F, {
                                    value: grandTotalAmount
                                })
                            })
                        ]
                    }),
                    showShippingFee && shippingFee > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLine, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Ph\xed vận chuyển")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShippingFee, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Currency */ .F, {
                                    value: shippingFee
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/cart",
                as: "/cart",
                passHref: true,
                legacyBehavior: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewCartButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: "miniCart",
                    contentName: "viewCartFromMiniCart",
                    target: "shoppingCart"
                })), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewCartButton, {
                        variant: "primary",
                        block: true,
                        tag: "a",
                        onClick: onHide,
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Xem giỏ h\xe0ng")
                    })
                }))
            })
        ]
    });
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject());
const ViewCartButtonWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject1());
const ViewCartButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z)(_templateObject2());
const EmptyCartWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject3());
const Footer = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject4());
const FooterLine = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject5());
const Body = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.div */ .z.div(_templateObject6());
const StyledEmptyCartPanel = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled */ .z)(components_EmptyCartPanel__WEBPACK_IMPORTED_MODULE_12__/* .EmptyCartPanel */ .m)(_templateObject7());
const GrandTotal = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.span */ .z.span(_templateObject8());
const ShippingFee = _teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .styled.span */ .z.span(_templateObject9());


/***/ })

}]);